var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-breadcrumbs',{staticClass:"px-0 pt-0",attrs:{"items":_vm.itemsList,"divider":"-"},scopedSlots:_vm._u([{key:"divider",fn:function(){return [_vm._v(" / ")]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }